import { useMutation } from '@apollo/client/react'
import * as Sentry from '@sentry/react'
import { toast } from 'sonner'
import {
  PORTAL_INVITE_ORG_MEMBER,
  type PortalInviteOrgMemberData,
  type PortalInviteOrgMemberVars,
} from '../api/operations'
import type { AssignableRole } from '../constants/assignableRoles'

export function useInviteOrgMember(options?: { onSuccess?: () => void }) {
  const [mutate, { loading, error }] = useMutation<
    PortalInviteOrgMemberData,
    PortalInviteOrgMemberVars
  >(PORTAL_INVITE_ORG_MEMBER, {
    // Por NOMBRE: refresca todas las páginas activas del listado.
    refetchQueries: ['PortalListOrgMembers'],
    awaitRefetchQueries: true,
    onError: (err) => {
      Sentry.captureException(err, {
        tags: { operation: 'PortalInviteOrgMember' },
      })
      toast.error('No se pudo enviar la invitación', {
        description: err.message,
      })
    },
  })

  const inviteMember = async ({ email, role }: { email: string; role: AssignableRole }) => {
    const result = await mutate({
      variables: {
        input: { email, role, businessesIds: [] },
      },
    })
    if (result.data?.portalInviteOrgMember) {
      toast.success('Invitación enviada', {
        description: `${email} recibirá un correo para unirse.`,
      })
      options?.onSuccess?.()
    }
    return result.data?.portalInviteOrgMember ?? null
  }

  return { inviteMember, loading, error }
}
